import { useAuth } from "@clerk/clerk-react";
import { Box, CircularProgress } from "@mui/material";
import { AlertContext } from "contexts/Alert";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext, useEffect, useState } from "react";
import { BentoCategory } from "schemas/dashboard";

import { PAGE_VISITED } from "constants/trackingProps";
import { fetcherAuth } from "utils/api";
import { trackEvent } from "utils/tracking";

import { Template } from "../ContactList/schema";
import {
  OrganizationBulkSendSettings,
  OrganizationBulkSendSettingsVersion,
} from "../Discover/Results/DiscoverFilter/AutomationVA/UpcomingPitchScheduleDialog/schema";
import OldVASettings from "./OldVASettings";
import VASettings from "./VASettings";

export default function VA() {
  // Contexts
  const { currentOrg } = useContext(OrganizationUserContext);
  const { setErrorAlert } = useContext(AlertContext);
  const { getToken } = useAuth();

  // States
  const [fetchLoading, setFetchLoading] = useState<boolean>(true);
  const [bulkSendEmailSetting, setBulkSendEmailSetting] = useState<
    number | null
  >(null);
  const [bulkSendSetting, setBulkSendSetting] =
    useState<OrganizationBulkSendSettings | null>(null);
  const [fallbackTemplates, setFallbackTemplates] = useState<Template[]>([]);
  const [categoriesToPickFrom, setCategoriesToPickFrom] = useState<
    BentoCategory[]
  >([]);

  const getCategoriesToPickFrom = async () => {
    try {
      const res = await fetcherAuth(
        getToken,
        `/api/organization/${currentOrg?.id}/bento-categories/onboarding?for_va=${true}`,
      );
      setCategoriesToPickFrom(res.onboardingBentoCategories);
    } catch (error) {
      setErrorAlert(error);
    }
  };

  const fetchSettings = async () => {
    try {
      const res = await fetcherAuth(
        getToken,
        `/api/organization/${currentOrg?.id}/bulk-send-settings`,
        "GET",
      );
      if (res.bulkSendSetting) {
        setBulkSendEmailSetting(res.bulkSendSetting.emailSettingId);
        setBulkSendSetting(res.bulkSendSetting);
        setFallbackTemplates(res.bulkSendSetting?.templates || []);
      }
      return res.templates;
    } catch (error) {
      setErrorAlert(error);
    }
  };

  const loadData = async () => {
    setFetchLoading(true);
    try {
      await Promise.all([fetchSettings(), getCategoriesToPickFrom()]);
    } finally {
      setFetchLoading(false);
    }
  };

  useEffect(() => {
    trackEvent(PAGE_VISITED);
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (fetchLoading) {
    return (
      <Box
        sx={{
          color: "#fff",
          zIndex: 9999,
          left: "50%",
          top: "50%",
          ml: "-20px",
          mt: "-20px",
          position: "absolute",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (bulkSendSetting?.version === OrganizationBulkSendSettingsVersion.v3) {
    return (
      <VASettings
        setBulkSendSetting={setBulkSendSetting}
        bulkSendSetting={bulkSendSetting}
        fallbackTemplates={fallbackTemplates}
        setFallbackTemplates={setFallbackTemplates}
        categoriesToPickFrom={categoriesToPickFrom}
      />
    );
  }

  return (
    <OldVASettings
      bulkSendSetting={bulkSendSetting}
      setBulkSendSetting={setBulkSendSetting}
      bulkSendEmailSetting={bulkSendEmailSetting}
      fallbackTemplates={fallbackTemplates}
      setFallbackTemplates={setFallbackTemplates}
      categoriesToPickFrom={categoriesToPickFrom}
    />
  );
}
